import React, { Component } from 'react';
import { Card, CardMedia, CardText } from 'material-ui/Card';
import Tabs from './components/tabs'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Card>
          <CardMedia>
            {/* <img src="kfsyscc_map.jpg" alt="" /> */}
          </CardMedia>
          <CardText>
            <Tabs />
          </CardText>
        </Card>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js